angular.module('impactx').config([
    '$mdThemingProvider',
    '$configProvider',
    function($mdThemingProvider, $configProvider) {

        // put this in themeFactory if angular material is updated so we can use $mdTheming.defineTheme()
        function addTheme(theme, palette, accentPalette, warnPalette) {
            $configProvider.customThemes.push(theme);
            $configProvider.configuredThemes.push(theme);
            $mdThemingProvider.theme(theme)
                .primaryPalette(palette)
                .accentPalette(accentPalette)
                .warnPalette(warnPalette)
                .backgroundPalette('backgroundPalette');
        }

        addTheme('customBBGRed', 'customBBGRed', 'shopAccent', 'warnPalette');
        addTheme('customBBGDarkBlue', 'customBBGDarkBlue', 'shopAccent', 'warnPalette');
        addTheme('customBBGDarkGreen', 'customBBGDarkGreen', 'shopAccent', 'warnPalette');
        addTheme('customBBGBrown', 'customBBGBrown', 'shopAccent', 'warnPalette');
        addTheme('customBBGPurple', 'customBBGPurple', 'shopAccent', 'warnPalette');
        addTheme('customBBGMagenta', 'customBBGMagenta', 'shopAccent', 'warnPalette');

        $mdThemingProvider.definePalette('customBBGRed', {
            '50': '#f6e4e4',
            '100': '#e9bbbb',
            '200': '#db8e8e',
            '300': '#cd6060',
            '400': '#c23e3e',
            '500': '#b71c1c',
            '600': '#b01919',
            '700': '#a71414',
            '800': '#991818',
            '900': '#900909',
            'A100': '#ffbebe',
            'A200': '#ff8b8b',
            'A400': '#ff5858',
            'A700': '#ff3f3f',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                'A100',
                'A200',
                'A400'
            ],
            'contrastLightColors': undefined
        });

        $mdThemingProvider.definePalette('customBBGMagenta', {
            '50': '#f1e2ea',
            '100': '#dbb7ca',
            '200': '#c487a7',
            '300': '#ac5684',
            '400': '#9a3269',
            '500': '#880e4f',
            '600': '#800c48',
            '700': '#750a3f',
            '800': '#690b3d',
            '900': '#580426',
            'A100': '#ff8ab1',
            'A200': '#ff578f',
            'A400': '#ff246d',
            'A700': '#ff0a5c',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                'A100',
                'A200'
            ],
            'contrastLightColors': undefined
        });

        $mdThemingProvider.definePalette('customBBGDarkGreen', {
            '50': '#e0eae8',
            '100': '#b3cac6',
            '200': '#80a6a0',
            '300': '#4d8279',
            '400': '#26685d',
            '500': '#004d40',
            '600': '#00463a',
            '700': '#003d32',
            '800': '#002d25',
            '900': '#00251c',
            'A100': '#60ffcf',
            'A200': '#2dffbf',
            'A400': '#00f9ad',
            'A700': '#00e09c',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                'A100',
                'A200',
                'A400',
                'A700'
            ],
            'contrastLightColors': undefined
        });

        $mdThemingProvider.definePalette('customBBGDarkBlue', {
            '50': '#e4e5f0',
            '100': '#babdd8',
            '200': '#8d91bf',
            '300': '#5f65a5',
            '400': '#3c4491',
            '500': '#1a237e',
            '600': '#171f76',
            '700': '#131a6b',
            '800': '#0f134b',
            '900': '#080c4e',
            'A100': '#8387ff',
            'A200': '#5056ff',
            'A400': '#1d24ff',
            'A700': '#030cff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                'A100'
            ],
            'contrastLightColors': undefined
        });

        $mdThemingProvider.definePalette('customBBGPurple', {
            '50': '#e9e3f1',
            '100': '#c9b9dd',
            '200': '#a58ac6',
            '300': '#805baf',
            '400': '#65379d',
            '500': '#4a148c',
            '600': '#431284',
            '700': '#3a0e79',
            '800': '#2c0c54',
            '900': '#22065c',
            'A100': '#ac8eff',
            'A200': '#875bff',
            'A400': '#6128ff',
            'A700': '#4e0fff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                'A100'
            ],
            'contrastLightColors': undefined
        });

        $mdThemingProvider.definePalette('customBBGBrown', {
            '50': '#e8e5e5',
            '100': '#c5bebd',
            '200': '#9f9391',
            '300': '#786865',
            '400': '#5b4744',
            '500': '#3e2723',
            '600': '#38231f',
            '700': '#301d1a',
            '800': '#2a1a17',
            '900': '#1b0e0c',
            'A100': '#ff6b5d',
            'A200': '#ff3d2a',
            'A400': '#f61600',
            'A700': '#dc1400',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                'A100'
            ],
            'contrastLightColors': undefined
        });
    }
]);